<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const appUrl = computed(() => route.query.url);
</script>

<template>
  <div class="flex h-full min-h-0 w-full bg-n-background">
    <div class="flex-1 min-h-0 w-full">
      <iframe
        v-if="appUrl"
        :src="appUrl"
        class="w-full h-full border-0"
        :title="$t('INTEGRATION_SETTINGS.DASHBOARD_APPS.TITLE')"
      />
      <div
        v-else
        class="flex items-center justify-center w-full h-full text-n-slate-11"
      >
        {{ $t('INTEGRATION_SETTINGS.DASHBOARD_APPS.FORM.URL_ERROR') }}
      </div>
    </div>
  </div>
</template>
